import React from 'react';
import {Link} from "react-router-dom";

const VendorLoginSellers = () => {
    return (
        <div className="vendor-login-sellers-wrapper">
            <div className="login-box position-relative">
                <div className="container login-container">
                    <h3 className="title-login">کسب و کار خود را با ما گسترش دهید.</h3>
                    <Link to="/vendorLogin" className="login-button"><span
                        className="text">ثبت‌نام به عنوان فروشنده در سایمان دیجیتال</span></Link>
                </div>
                <img src="./assets/vendorImages/2108-[Converted].png" alt="asdf"
                     className="image-login position-absolute"/>
            </div>
        </div>
    );
};

export default VendorLoginSellers;
